__turbopack_context__.v({
  "btn": "_5piwbG_btn",
  "btnFooter": "_5piwbG_btnFooter",
  "btnText": "_5piwbG_btnText",
  "cards": "_5piwbG_cards",
  "content": "_5piwbG_content",
  "headContact": "_5piwbG_headContact",
  "p": "_5piwbG_p",
  "page-body-wrap": "_5piwbG_page-body-wrap",
  "pagehero": "_5piwbG_pagehero",
  "paragraph": "_5piwbG_paragraph",
  "paragraph-content": "_5piwbG_paragraph-content",
  "phonecontent": "_5piwbG_phonecontent",
  "section": "_5piwbG_section",
  "store": "_5piwbG_store",
  "t": "_5piwbG_t",
  "textPink": "_5piwbG_textPink",
  "title": "_5piwbG_title",
  "wrap-container": "_5piwbG_wrap-container",
  "wrap-content": "_5piwbG_wrap-content",
});
